import styled from "styled-components";
import { CssRule } from "../../../../../themes/architecture/css-helpers/css-rule";
import {UserMenuCloseIconDefaultBox} from "./user-menu-close-icon.default.box";

export const UserMenuCloseIconSiBox = styled(UserMenuCloseIconDefaultBox)`
  border: 2px solid ${({theme}) => theme.colors.textMiddleDark};
  ${CssRule.For.mobile.build()} &{
    color: ${({theme}) => theme.colors.textContrast};
    border-color: ${({theme}) => theme.colors.boxBorderContrast};
  }
`